import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import { PessoaType } from "models/person_type";
import FormClient from "../clients/components/Form";
import useClients from "../clients/hooks/useClients";
import FormOrder from "./components/Form";
import OrderEntregavel from "./components/OrderEntregavel";
import OrderMidia from "./components/OrderMidia";
import Print from "./components/Print";
import OrderTable from "./components/Table";
import useOrder from "./hooks/useOrder";
import { ConditionalRenderer } from "../components/ConditionalRenderer";
import { SimpleConditionalFrame } from "../components/SimpleConditionalFrame";

export default function Orders() {
  const {
    add,
    cancelRef,
    closeDelete,
    error,
    errorMsg,
    errorTitle,
    selectedOrder,
    show,
    showDelete,
    deletar,
    edit,
    list,
    remove,
    loading,
    save,
    showModal,
    onChangeClient,
    selectedClient,
    selectedAgency,
    closeError,
    print,
    showPrint,
    showPrintModal,
    agency,
    calculaTotalOrder,
    clients,
    totalOrder,
    totalItens,
    onChangeAgency,
    itens,
    nomeRef,
    changeItem,
    removeItem,
    saveCategory,
    showItem,
    showItemModal,
    contatoCliente,
    emailCliente,
    telefoneCliente,
    listContatoCliente,
    contatoAgencia,
    emailAgencia,
    telefoneAgencia,
    listContatoAgencia,
    changeInput,
    condicaoPagamento,
    modeloNegocio,
    onChangeModeloNegocio,
    onChangePagamento,
    selectedCondicaoPagamento,
    selectedModeloNegocio,
    showAgenciaInput,
    showAgenciaInputModal,
    usuario,
    filiais,
    onChangeFilial,
    selectedFilial,
    entregavel,
    midias,
    onChangeEntregavel,
    onChangeMidias,
    selectedEntregaveis,
    selectedMidias,
    data,
    validade,
    cadastrarMidia,
    midiaNomeRef,
    showCadasdastrarMidiaModal,
    showCadastrarMidia,
    cadastrarEntregavel,
    entregavelNomeRef,
    showCadastrarEntregavel,
    showCadasdastrarEntregavelModal,
    reorder,
    enableDrag,
    isDragable,
    carta,
    changeCarta,
    nome,
    descricao,
    exportExcel,
    filteredClients,
    filteredAgency,
    changeFootNotes,
    footNotes,
    selectedFootNote,
    desconto,
    acrescimo,
    comissao,
    totalCalculado,
    tipoAcrescimo,
    tipoComissao,
    tipoDesconto,
    onChangeTemplate,
    templateList,
    cancelRascunho,
    cancelSaveDraft,
    showRascunho,
    saveDraft,
    loadingDraft,
    listDraft,
    editDraft,
    deleteDraft,
    selectedDraft,
    removeDraft,
    descricoes,
    changeCadastroDescricao,
    selectedCadastro,
    showContatoModal,
    showContactModal,
    editContact,
    saveContact,
    selectedContact,
    changeType,
    type,
    showError,
    reloadDataClients,
    cancelAprovacao,
    showAprovacao,
    showAprovacaoModal,
    loadprovacao,
    saveAprovacao,
    addRowItem,
    deleteRow,
    editRow,
    itemList

  } = useOrder();

  const {
    enderecoList, showFormPessoa, adicionarContato, adicionarEndereco, bairroRef,
    cargoContatoRef, cepRef, changeFilial, changeItemPessoa, cidadeRef, classificacaoList, classificacaoRef, client,
    complementoRef, contatoList, contribuinteRef, deleteContato, showPessoa, idTipoRef, documentoRef, razaoSocialRef,
    nomeFantasiaRef, inscricaoMunicipalRef, inscricaoEstadualRef, tipoPessoaList, ruaRef, numeroRef, estadoRef, principalRef,
    loadCEP, viaCepEnd, deleteEnd, emailContatoRef, principalContatoRef, nomeContatoRef, filial, telefoneContatoRef, pessoaFilial,
    nomeClinteRef, editPessoa, saveCliente, errorCliente, errorMsgCliente, errorTitleCliente, cancelPessoaRef, closeErrorPessoa,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta,
    contaList


  } = useClients();
  const editarPessoa = (item: PessoaType) => {
    if (item === undefined || item === null) {
      showError('Erro!', 'Selecione o Cliente/Agência para editar seus dados!')
    } else {
      editPessoa(item);
    }
  }

  const savePersonData = async () => {
    await saveCliente();
    await reloadDataClients();
  }

  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal(false)}
                title={selectedOrder !== null ? "Editar Orçamento" : "Novo Orçamento"}
              >
                <FormOrder
                  accountSelected={selectedOrder}
                  loading={loading}
                  save={save}
                  show={show}
                  showModal={showModal}
                  error={error}
                  onChangeClient={onChangeClient}
                  selectedClient={selectedClient}
                  agency={agency}
                  clients={clients}
                  onChangeAgency={onChangeAgency}
                  calculaTotalOrder={calculaTotalOrder}
                  total={totalOrder}
                  totalItens={totalItens}
                  borderColor={borderColor}
                  itens={itens}
                  nomeRef={nomeRef}
                  showCategory={showItem}
                  showItemModal={showItemModal}
                  changeItem={changeItem}
                  removeItem={removeItem}
                  saveItem={saveCategory}
                  showCadastraraMidia={showCadastrarMidia}
                  showCadastrarEntregavel={showCadastrarEntregavel}
                  selectedAgency={selectedAgency}
                  changeInput={changeInput}
                  usuario={usuario}
                  filiais={filiais}
                  onChangeFilial={onChangeFilial}
                  selectedFilial={selectedFilial}
                  showAgenciaInput={showAgenciaInput}
                  showAgenciaInputModal={showAgenciaInputModal}
                  condicaoPagamento={condicaoPagamento}
                  modeloNegocio={modeloNegocio}
                  onChangeModeloNegocio={onChangeModeloNegocio}
                  onChangePagamento={onChangePagamento}
                  selectedCondicaoPagamento={selectedCondicaoPagamento}
                  selectedModeloNegocio={selectedModeloNegocio}
                  entregavel={entregavel}
                  midias={midias}
                  onChangeEntregavel={onChangeEntregavel}
                  onChangeMidias={onChangeMidias}
                  selectedEntregaveis={selectedEntregaveis}
                  selectedMidias={selectedMidias}
                  data={data}
                  validade={validade}
                  reorder={reorder}
                  drag={enableDrag}
                  isDragable={isDragable}
                  contatoAgencia={contatoAgencia}
                  emailAgencia={emailAgencia}
                  telefoneAgencia={telefoneAgencia}
                  listContatoAgencia={listContatoAgencia}
                  contatoCliente={contatoCliente}
                  emailCliente={emailCliente}
                  telefoneCliente={telefoneCliente}
                  listContatoCliente={listContatoCliente}
                  carta={carta}
                  changeCarta={changeCarta}
                  nome={nome}
                  descricao={descricao}
                  exportExcel={exportExcel}
                  filteredClients={filteredClients}
                  filteredAgency={filteredAgency}
                  changeFootNotes={changeFootNotes}
                  footNotes={footNotes}
                  selectedFootNote={selectedFootNote}
                  acrescimo={acrescimo}
                  comissao={comissao}
                  desconto={desconto}
                  totalCalculado={totalCalculado}
                  tipoAcrescimo={tipoAcrescimo}
                  tipoComissao={tipoComissao}
                  tipoDesconto={tipoDesconto}
                  onChangeTemplate={onChangeTemplate}
                  templateList={templateList}
                  changeCadastroDescricao={changeCadastroDescricao}
                  descricoes={descricoes}
                  selectedCadastro={selectedCadastro}
                  changeType={changeType}
                  editContact={editContact}
                  saveContact={saveContact}
                  selectedContact={selectedContact}
                  showContactModal={showContactModal}
                  showContatoModal={showContatoModal}
                  type={type}
                  showFormPessoa={showFormPessoa}
                  editPessoa={editarPessoa}
                  showAprovacaoModal={showAprovacaoModal}
                  addRowItem={addRowItem}
                  deleteRow={deleteRow}
                  editRow={editRow}
                  itemList={itemList}

                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <OrderTable
              add={add}
              cancelRef={cancelRef}
              closeDelete={closeDelete}
              deletar={deletar}
              edit={edit}
              list={list}
              remove={remove}
              showDelete={showDelete}
              print={print}
              listDraft={listDraft}
              editDraft={editDraft}
              deleteDraft={deleteDraft}
              selectedDraft={selectedDraft}
              removeDraft={removeDraft}
            />
          </SimpleGrid>
        )}
      />

      <OrderMidia
        brandStars={brandStars}
        error={error}
        loading={loading}
        nomeRef={midiaNomeRef}
        save={cadastrarMidia}
        show={showCadasdastrarMidiaModal}
        showModal={showCadastrarMidia}
        textColor={textColor}

      />

      <OrderEntregavel
        brandStars={brandStars}
        error={error}
        loading={loading}
        nomeRef={entregavelNomeRef}
        save={cadastrarEntregavel}
        show={showCadasdastrarEntregavelModal}
        showModal={showCadastrarEntregavel}
        textColor={textColor}

      />

      <FormClient
        enderecoList={enderecoList}
        accountSelected={client}
        brandStars={brandStars}
        error={error}
        loading={loading}
        save={savePersonData}
        nomeRef={nomeClinteRef}
        show={showPessoa}
        showModal={showFormPessoa}
        textColor={textColor}
        idTipoRef={idTipoRef}
        classificacaoRef={classificacaoRef}
        documentoRef={documentoRef}
        razaoSocialRef={razaoSocialRef}
        nomeFantasiaRef={nomeFantasiaRef}
        inscricaoMunicipalRef={inscricaoMunicipalRef}
        inscricaoEstadualRef={inscricaoEstadualRef}
        contribuinteRef={contribuinteRef}
        classificacaoList={classificacaoList}
        tipoPessoaList={tipoPessoaList}
        bairroRef={bairroRef}
        cepRef={cepRef}
        ruaRef={ruaRef}
        numeroRef={numeroRef}
        complementoRef={complementoRef}
        cidadeRef={cidadeRef}
        estadoRef={estadoRef}
        principalRef={principalRef}
        loadCEP={loadCEP}
        viaCepEnd={viaCepEnd}
        adicionarEnd={adicionarEndereco}
        deleteEnd={deleteEnd}
        contatoList={contatoList}
        deleteContato={deleteContato}
        adicionarContato={adicionarContato}
        cargoContatoRef={cargoContatoRef}
        emailContatoRef={emailContatoRef}
        nomeContatoRef={nomeContatoRef}
        principalContatoRef={principalContatoRef}
        telefoneContatoRef={telefoneContatoRef}
        changeItem={changeItemPessoa}
        filial={filial}
        changeFilial={changeFilial}
        pessoaFilial={pessoaFilial}
        adcionarConta={adcionarConta}
        agenciaRef={agenciaRef}
        bancoRef={bancoRef}
        contaList={contaList}
        deleteConta={deleteConta}
        descricaoRef={descricaoRef}
        documentoContaRef={documentoContaRef}
        numeroContaRef={numeroContaRef}
        obsRef={obsRef}
        tipoPessoaRef={tipoPessoaRef}
        tipoRef={tipoRef}
        titularRef={titularRef}

      />


      <Print
        order={selectedOrder}
        show={showPrint}
        showModal={showPrintModal}
      />
      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>
              {errorMsg}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={closeError} colorScheme={"blue"}>
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      <AlertDialog
        isOpen={showRascunho}
        leastDestructiveRef={cancelRascunho}
        onClose={cancelSaveDraft}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Deseja Salvar o Rascunho?
            </AlertDialogHeader>

            <AlertDialogBody>
              Salvando como rascunho você pode continuar preenchendo o orçamento da forma que preferir.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={cancelSaveDraft} colorScheme={"red"} mr={4}>
                Cancelar
              </Button>

              <Button onClick={saveDraft} colorScheme={"blue"} isLoading={loadingDraft}>
                Salvar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>



      <AlertDialog
        isOpen={showAprovacao}
        leastDestructiveRef={cancelAprovacao}
        onClose={() => { showAprovacaoModal(false) }}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Deseja Aprovar o Orcamento?
            </AlertDialogHeader>

            <AlertDialogBody>
              Ao aprovar o Orçamento o mesmo será enviado para a área de projetos e poderá ser executado.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelAprovacao} onClick={() => { showAprovacaoModal(false) }} colorScheme={"red"} mr={4}>
                Cancelar
              </Button>

              <Button onClick={saveAprovacao} colorScheme={"blue"} isLoading={loadprovacao}>
                Aprovar
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>



      <AlertDialog
        isOpen={errorCliente}
        leastDestructiveRef={cancelPessoaRef}
        onClose={closeErrorPessoa}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitleCliente}
            </AlertDialogHeader>

            <AlertDialogBody>
              {errorMsgCliente}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelPessoaRef}
                onClick={closeErrorPessoa}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}
